import { Loader2 } from "lucide-react";
import Modal from "./Modal";
import Button from "@/components/ui/Button";

// Confirmation step for an irreversible action.
//
// Several admin tables wired a trash icon straight to a hard DELETE, so a
// mis-aimed click destroyed a coupon / changelog entry / firewall rule with no
// undo and no warning. Pass the row being acted on as `open` so the dialog and
// the pending target stay in one piece of state.
export default function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel = "Delete",
  busy = false,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      open={!!open}
      onClose={onCancel}
      title={title}
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={onCancel} disabled={busy}>Cancel</Button>
          {/* variant="danger", not a bg-* override: cn() is a plain joiner, so an
              override leaves the variant's own colour on the element and which one
              wins depends on Tailwind's output order rather than on intent. */}
          <Button size="sm" variant="danger" onClick={onConfirm} disabled={busy}>
            {busy ? <Loader2 size={15} className="animate-spin" /> : confirmLabel}
          </Button>
        </div>
      }
    >
      <p className="text-sm text-slate-600 dark:text-slate-300">{body}</p>
    </Modal>
  );
}
